<template>
    <div id="app">
        <Header :currentComponent="currentComponent" @changeComponent="changeComponent"></Header>
        <transition name="fade">
            <component v-bind:is="currentC"></component>
        </transition>
    </div>
</template>

<script>
    import One from "./views/One";
    import Two from './views/Two'
    import Three from './views/Three'
    import Header from './components/Header'
    import {swiper, swiperSlide} from "vue-awesome-swiper";
    import 'swiper/dist/css/swiper.min.css'
    export default {
        name: "app",
        components: {
            One,
            Two,
            Three,
            Header,
            swiper,
            swiperSlide
        },
        data() {
            return {
                currentComponent: '2',
                swiperOption: {
                    autoplay: {
                        delay: 5000
                    },
                    loop: true,
                    pagination: {
                        el: ".swiper-pagination",
                    }
                }
            }
        },
        computed: {
            currentC: function () {
                if (this.currentComponent === '1') return 'One'
                else if (this.currentComponent === '2') return 'Two'
                else return 'Three'
            }
        },
        methods: {
            changeComponent: function (currentComponent) {
                this.currentComponent = currentComponent
            }
        }
    };
</script>

<style lang="stylus">
    body
        background-color #CEAEA5

    .swiper-img
        width 97.3333vw
        margin 4vw 0
    .one-img
        width 92.8vw
        height 46.133vw
        object-fit cover
        object-position center center
        margin-bottom 1.067vw

    .two-img
        width 45.6vw
        height 31.733vw
        margin-bottom 1.067vw

    .one-full-img
        width 92.8vw
        margin-bottom 1.067vw

    *
        margin 0
        padding 0

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }
    .cover-box
        position relative
        .content-box
            background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));
            position absolute
            width 100%
            height 20%
            bottom 2vw
            color #fff
            font-size 12px
            display flex
            align-items center
            justify-content center
</style>>
